import React, { useId } from 'react'
import { clsx } from 'clsx'

export const InputField = ({ label, startIcon, endIcon, error, required, value, type, inputClasses, ...props }) => {
  const id = useId()

  const inputProps = {
    id,
    value,
    required,
    ...props,
  }

  return (
    <div className="dome-d-flex dome-flex-column auto-questionnaire-input-field">
      <label htmlFor={id} className="dome-p3 dome-color-med-grey">
        {label}
        {required && '*'}
      </label>
      <div className="input-field-container dome-d-flex dome-align-center dome-gap12">
        {startIcon && <span>{startIcon}</span>}
        {type === 'textarea' ? (
          <textarea className={clsx(inputClasses)} {...inputProps} />
        ) : (
          <input type={type} className={clsx(inputClasses)} {...inputProps} />
        )}
        {endIcon && <span>{endIcon}</span>}
      </div>
      {error && (
        <div style={{ color: '#F64141', fontSize: '12px', marginTop: '2px' }}>
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}
